import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { IftaLabelModule } from 'primeng/iftalabel';
import { ProgressSpinner } from 'primeng/progressspinner';
import { Select } from 'primeng/select';
import { SelectButton } from 'primeng/selectbutton';
import Media from '../../../../../../types/media/Media';
import MediaPreviewDTO from '../../../../../../types/media/MediaPreviewDTO';
import { MediaService } from '../../../../services/media.service';
import { UploadMediaComponent } from '../upload-media/upload-media.component';

@Component({
    selector: 'app-select-or-upload-media',
    templateUrl: './select-or-upload-media.component.html',
    styleUrls: [ './select-or-upload-media.component.scss' ],
    imports: [
        IftaLabelModule,
        FormsModule,
        Select,
        UploadMediaComponent,
        SelectButton,
        ProgressSpinner
    ]
})
export class SelectOrUploadMediaComponent implements OnInit, OnChanges {
    @Input() public selectedMedia: Media | undefined = undefined;
    @Output() public selectedMediaChange: EventEmitter<Media> = new EventEmitter<Media>();

    public mediaOptions: MediaPreviewDTO[] = []; // Media options for the select
    public selectedMediaPreview: MediaPreviewDTO | undefined = undefined; // Currently selected media

    public viewOptions: any[] = [
        { label: 'Select Image', value: 'select' },
        { label: 'Upload', value: 'upload' }
    ];

    public view: string = 'select';
    public waiting: boolean = false;

    constructor(private mediaService: MediaService, private messageService: MessageService) {
    }

    public ngOnInit(): void {
        this.loadAllMedia();
    }

    public ngOnChanges(): void {
        if (this.selectedMedia) {
            // If selectedMedia is defined, find and set the corresponding preview
            this.selectedMediaPreview = this.mediaOptions.find((media) => media.id === this.selectedMedia?.id);
        } else {
            // If selectedMedia is undefined, also set selectedMediaPreview to undefined
            this.selectedMediaPreview = undefined;
        }
    }

    public onMediaPreviewSelected(selectedMediaPreview: MediaPreviewDTO): void {
        if (selectedMediaPreview) {
            this.mediaService.getMedia(selectedMediaPreview.id).then((media) => {
                this.selectedMediaChange.emit(media);
            }).catch((error) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
            });
        } else {
            this.selectedMediaChange.emit(undefined);
        }
    }

    /**
     * Loads all media items at once.
     */
    private loadAllMedia(): void {
        this.mediaService
            .getAllMediaPreviews()
            .then((mediaPreviews) => {
                this.mediaOptions = mediaPreviews;
            })
            .catch((error) => {
                console.error('Error loading media previews:', error);
            });
    }

    public onUploadSuccess(mediaId: number) {
        // Introduce a 2-second delay to ensure everything is created
        this.waiting = true;
        setTimeout(() => {
            this.mediaService.getMedia(mediaId).then((media) => {
                this.selectedMediaChange.emit(media);

                // Create a new MediaPreviewDTO and update the selected preview
                const mediaPreview = new MediaPreviewDTO({
                    id: media.id,
                    filename: media.filename,
                    cloudfrontUrl: media.content?.preview?.cloudfrontUrl,
                });

                this.waiting = false;

                this.mediaOptions.push(mediaPreview);
                this.selectedMediaPreview = mediaPreview;
                this.selectedMediaChange.emit(media);
                this.view = 'select';
            }).catch((error) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
            });
        }, 2000); // Delay in milliseconds
    }

}
